import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TransferSlaService from '_services/transfer-sla-service';

export const fetchTransferSla = createAsyncThunk(
  'transferSla/fetch',
  async (params, { signal }) => {
    return await TransferSlaService.getTransferSla(params, signal);
  }
);

export const patchTransferOverride = createAsyncThunk(
  'transferSla/patchOverride',
  async ({ bookingId, kpiKey, pass, passReason, ignore }) => {
    let overrideValue;
    if (ignore) {
      overrideValue = { ignore: true, pass: null, passReason, reason: passReason };
    } else {
      overrideValue = { ignore: false, pass, passReason, reason: passReason };
    }
    const patch = kpiKey
      ? { transferSlaOverride: { [kpiKey]: overrideValue } }
      : { transferSlaOverride: overrideValue };
    await TransferSlaService.patchBooking(bookingId, patch);
    return { bookingId };
  }
);

const initialState = {
  data: null,
  status: 'idle',
  error: null,
  patchStatus: 'idle',
};

const transferSlaSlice = createSlice({
  name: 'transferSla',
  initialState,
  reducers: {
    resetTransferSla: (state) => {
      state.data = null;
      state.status = 'idle';
      state.error = null;
    },
    resetPatchTransferOverrideStatus: (state) => {
      state.patchStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferSla.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchTransferSla.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchTransferSla.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(patchTransferOverride.pending, (state) => {
        state.patchStatus = 'loading';
      })
      .addCase(patchTransferOverride.fulfilled, (state) => {
        state.patchStatus = 'succeeded';
      })
      .addCase(patchTransferOverride.rejected, (state) => {
        state.patchStatus = 'failed';
      });
  },
});

export const selectTransferSlaData = (state) => state.transferSla.data;
export const selectTransferSlaStatus = (state) => state.transferSla.status;
export const selectTransferSlaError = (state) => state.transferSla.error;
export const selectPatchTransferOverrideStatus = (state) => state.transferSla.patchStatus;

export const { resetTransferSla, resetPatchTransferOverrideStatus } = transferSlaSlice.actions;

export default transferSlaSlice.reducer;
